
import React from 'react';
import { Typography } from "@material-ui/core"
import InputVsBeginn from './form-antrag/InputVsBeginn';
import FormVn from './form-vn/FormVn';
import FormBank from './form-bank/FormBank';
import FormOptIn from './form-optin/FormOptIn';
import AlertFormError from '../../../../form/AlertFormError';
import FormVorschaden from './form-vorschaden/FormVorschaden';
import FormVvi from './form-vvi/FormVvi';
// import InputVsBeginn2 from './form-antrag/InputVsBeginn2';

const InputTitel: React.FC<{ text: string }> = ({ text }) => (
    <div style={{ marginBottom: 10 }}>
        <Typography variant='h4' color='textPrimary'>{text}</Typography>
    </div>);


const Block: React.FC = ({ children }) => <div style={{ paddingBottom: 60 }}>{children}</div>;

const Form: React.FC = () => {

    return (
        <>
            {/* Versicherungsnehmer */}
            <Block>
                <FormVn />
            </Block>

            {/* Versicherungsbeginn */}
            <Block>
                <InputTitel text="Wann soll Ihre Versicherung beginnen?" />
                <InputVsBeginn />
            </Block>
            {/* 
            <Block>
                <InputTitel text="Wann soll Ihre Versicherung beginnen?" />
                <InputVsBeginn2 />
            </Block>
*/}
            {/* Vorschaden */}
            <Block>
                <InputTitel text="Gibt es von Ihren Hunden verursachte Vorschäden?" />
                <FormVorschaden />
            </Block>


            {/* Bankverbindung */}
            <Block>
                <FormBank />
            </Block>

            {/* Opt-in Werbekontaktaufnahmen */}
            <Block>
                <FormOptIn />
            </Block>

            {/* Vorvertragliche Informationen */}
            <Block>
                <FormVvi />
            </Block>

            <AlertFormError />

        </>);

}

export default Form;